/**
 * Ad-click tracking: captures UTM params + fbclid/gclid from the landing URL
 * into sessionStorage on first touch, and replays them into every lead submit
 * so we can attribute leads to Meta campaigns.
 */

const TRACKING_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
];

const STORE_KEY = "bja_tracking";

/** Call once on landing mount — saves any ad params from the URL. */
export function captureAdTracking() {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = {};
    TRACKING_KEYS.forEach((k) => {
      const v = q.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length > 0) {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(found));
    }
  } catch (_) {
    /* noop */
  }
}

/** Returns the saved ad params ({} when the visitor came direct/organic). */
export function getAdTracking() {
  try {
    return JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
  } catch (_) {
    return {};
  }
}
